/* (ignored) */


//////////////////
// WEBPACK FOOTER
// ws (ignored)
// module id = 2980
// module chunks = 0 1